import noop from "lodash/fp/noop";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { createSelector } from "reselect";
import { getOrderedTemplatesByModuleId } from "src/store/modules/selectors";
import { EMPTY_SOR } from "../../../../../globalConsts";
import { useFavouriteStatusToggler } from "../../../../../store/favouriteTemplates/hooks/useActions";
import { getIdsOfFavouriteTemplates } from "../../../../../store/favouriteTemplates/selectors";
import { createOverviewLink } from "../../../../../utils/internalLinksParsing";
import { OnClickSideEffects } from "../../types";
import { TemplateData } from "./ModuleLinkHubVariant";

type Params = {
  onClickSideEffects?: (id: number) => void;
  toggleFavourite: (id: number, isFavourite: boolean) => void;
};

const makeGetTemplateDataFromIds = ({
  onClickSideEffects = noop,
  toggleFavourite,
}: Params) =>
  createSelector(
    getOrderedTemplatesByModuleId,
    getIdsOfFavouriteTemplates,
    (templatesData, favouriteIds): TemplateData[] =>
      templatesData.map((templateData) => {
        const {
          id,
          name = "",
          image = "",
          type,
          description = "",
        } = templateData;

        const isFavorite = favouriteIds.includes(templateData.id);

        return {
          id,
          templateId: id,
          icon: image,
          isFavourite: isFavorite,
          label: name,
          description,
          linkTo: createOverviewLink({ id, type }),
          toggleFavourite: () => toggleFavourite(id, isFavorite),
          onClick: () => onClickSideEffects(id),
        };
      })
  );

const useTemplateDataFromIds = (
  moduleId: number, // should be memoized, but already is if you get it with reselect
  onClickSideEffects?: OnClickSideEffects // SHOULD BE MEMOIZED!
): TemplateData[] => {
  const toggleFavourite = useFavouriteStatusToggler();
  // Furt makeGet pattern kvůli tomu curryingu
  // (abych tam dokázal poslat toggleFavourite a onClickSideEffects)
  const getTemplateDataFromIds = useMemo(
    () => makeGetTemplateDataFromIds({ toggleFavourite, onClickSideEffects }),
    [toggleFavourite, onClickSideEffects]
  );

  return useSelector((state) => getTemplateDataFromIds(state, moduleId));
};

export default useTemplateDataFromIds;
